import { render, staticRenderFns } from "./Defect.vue?vue&type=template&id=8862f106&scoped=true&"
import script from "./Defect.vue?vue&type=script&lang=js&"
export * from "./Defect.vue?vue&type=script&lang=js&"
import style0 from "./Defect.vue?vue&type=style&index=0&id=8862f106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8862f106",
  null
  
)

export default component.exports